import React, { useState } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import CandidateFilterPanel from './components/CandidateFilterPanel';
import CandidateCard from './components/CandidateCard';
import CandidateDetailModal from './components/CandidateDetailModal';
import BulkActionBar from './components/BulkActionBar';
import SavedFilterPresets from './components/SavedFilterPresets';

const CandidateManagement = () => {
  const [filters, setFilters] = useState({
    status: 'all',
    qualification: [],
    experience: 'all',
    skills: [],
    matchScore: 0,
    location: [],
    salaryRange: { min: 0, max: 2000000 },
    availability: 'all'
  });
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [viewMode, setViewMode] = useState('grid');
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [savedPresets, setSavedPresets] = useState([
    {
      id: 1,
      name: 'Senior Developers',
      filters: {
        status: 'all',
        qualification: ['btech', 'mtech'],
        experience: '5+',
        skills: ['React', 'Node.js'],
        matchScore: 80,
        location: ['Bangalore, Karnataka', 'Pune, Maharashtra'],
        salaryRange: { min: 800000, max: 2000000 },
        availability: 'all'
      }
    },
    {
      id: 2,
      name: 'Fresh Graduates',
      filters: {
        status: 'Applied',
        qualification: ['btech', 'bca'],
        experience: 'fresher',
        skills: [],
        matchScore: 60,
        location: [],
        salaryRange: { min: 0, max: 400000 },
        availability: 'immediate'
      }
    }
  ]);

  const mockCandidates = [
  {
    id: 1,
    name: 'Rahul Sharma',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ef2015b3-1763301538793.png",
    photoAlt: 'Professional headshot of young Indian man in formal attire',
    qualification: 'B.Tech Computer Science',
    experience: '2 years',
    skills: ['React', 'Node.js', 'MongoDB', 'AWS'],
    location: 'Bangalore, Karnataka',
    matchScore: 92,
    status: 'Applied',
    appliedDate: '2026-02-01T10:30:00',
    email: 'rahul.sharma@example.com',
    phone: '+91 98765 43210',
    resume: 'rahul_sharma_resume.pdf',
    salaryExpectation: 600000,
    availability: 'immediate'
  },
  {
    id: 2,
    name: 'Priya Patel',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee2bcef3-1763301295581.png",
    photoAlt: 'Professional portrait of young woman with long dark hair',
    qualification: 'MCA',
    experience: '3 years',
    skills: ['Python', 'Django', 'PostgreSQL', 'Docker'],
    location: 'Mumbai, Maharashtra',
    matchScore: 88,
    status: 'Shortlisted',
    appliedDate: '2026-01-30T14:20:00',
    email: 'priya.patel@example.com',
    phone: '+91 98765 43211',
    resume: 'priya_patel_resume.pdf',
    salaryExpectation: 750000,
    availability: '1-month'
  },
  {
    id: 3,
    name: 'Amit Kumar',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a7d4290a-1763293336648.png",
    photoAlt: 'Professional photo of man in business casual attire',
    qualification: 'B.Tech IT',
    experience: '1 year',
    skills: ['Java', 'Spring Boot', 'MySQL', 'Git'],
    location: 'Delhi NCR',
    matchScore: 75,
    status: 'Under Review',
    appliedDate: '2026-01-28T09:15:00',
    email: 'amit.kumar@example.com',
    phone: '+91 98765 43212',
    resume: 'amit_kumar_resume.pdf',
    salaryExpectation: 450000,
    availability: 'immediate'
  },
  {
    id: 4,
    name: 'Sneha Reddy',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_12672b149-1763294392419.png",
    photoAlt: 'Professional headshot of woman with confident smile',
    qualification: 'B.Sc Computer Science',
    experience: '4 years',
    skills: ['Angular', 'TypeScript', 'Firebase', 'Azure'],
    location: 'Hyderabad, Telangana',
    matchScore: 95,
    status: 'Interview Scheduled',
    appliedDate: '2026-01-25T11:45:00',
    email: 'sneha.reddy@example.com',
    phone: '+91 98765 43213',
    resume: 'sneha_reddy_resume.pdf',
    salaryExpectation: 900000,
    availability: '2-months'
  },
  {
    id: 5,
    name: 'Vikram Singh',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a58c58e8-1763294332999.png",
    photoAlt: 'Professional portrait of man in formal shirt',
    qualification: 'M.Tech CSE',
    experience: '5 years',
    skills: ['Vue.js', 'Laravel', 'Redis', 'Kubernetes'],
    location: 'Pune, Maharashtra',
    matchScore: 85,
    status: 'Rejected',
    appliedDate: '2026-01-22T16:30:00',
    email: 'vikram.singh@example.com',
    phone: '+91 98765 43214',
    resume: 'vikram_singh_resume.pdf',
    salaryExpectation: 1200000,
    availability: '1-month'
  },
  {
    id: 6,
    name: 'Anjali Mehta',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_107ab99de-1763301050685.png",
    photoAlt: 'Professional photo of woman with glasses',
    qualification: 'BCA',
    experience: 'Fresher',
    skills: ['HTML', 'CSS', 'JavaScript', 'React'],
    location: 'Ahmedabad, Gujarat',
    matchScore: 68,
    status: 'Applied',
    appliedDate: '2026-02-02T08:00:00',
    email: 'anjali.mehta@example.com',
    phone: '+91 98765 43215',
    resume: 'anjali_mehta_resume.pdf',
    salaryExpectation: 350000,
    availability: 'immediate'
  }];


  const filteredCandidates = mockCandidates?.filter((candidate) => {
    if (filters?.status !== 'all' && candidate?.status !== filters?.status) return false;
    if (filters?.experience !== 'all') {
      if (filters?.experience === 'fresher' && candidate?.experience !== 'Fresher') return false;
      if (filters?.experience === '0-2' && !['Fresher', '1 year', '2 years']?.includes(candidate?.experience)) return false;
      if (filters?.experience === '3-5' && !['3 years', '4 years', '5 years']?.includes(candidate?.experience)) return false;
      if (filters?.experience === '5+' && !['5 years', '6 years', '7 years', '8 years']?.includes(candidate?.experience)) return false;
    }
    if (filters?.matchScore > 0 && candidate?.matchScore < filters?.matchScore) return false;
    
    if (filters?.location?.length > 0 && !filters?.location?.includes(candidate?.location)) return false;
    
    if (candidate?.salaryExpectation < filters?.salaryRange?.min || candidate?.salaryExpectation > filters?.salaryRange?.max) return false;
    
    if (filters?.availability !== 'all' && candidate?.availability !== filters?.availability) return false;
    
    if (filters?.skills?.length > 0) {
      const hasMatchingSkill = filters?.skills?.some(skill => 
        candidate?.skills?.some(candidateSkill => 
          candidateSkill?.toLowerCase()?.includes(skill?.toLowerCase())
        )
      );
      if (!hasMatchingSkill) return false;
    }
    
    return true;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleClearFilters = () => {
    setFilters({
      status: 'all',
      qualification: [],
      experience: 'all',
      skills: [],
      matchScore: 0,
      location: [],
      salaryRange: { min: 0, max: 2000000 },
      availability: 'all'
    });
  };

  const handleSavePreset = (presetName) => {
    const newPreset = {
      id: Date.now(),
      name: presetName,
      filters: { ...filters }
    };
    setSavedPresets([...savedPresets, newPreset]);
  };

  const handleLoadPreset = (preset) => {
    setFilters(preset?.filters);
  };

  const handleDeletePreset = (presetId) => {
    setSavedPresets(savedPresets?.filter(p => p?.id !== presetId));
  };

  const handleSelectCandidate = (candidateId) => {
    setSelectedCandidates((prev) =>
    prev?.includes(candidateId) ?
    prev?.filter((id) => id !== candidateId) :
    [...prev, candidateId]
    );
  };

  const handleSelectAll = () => {
    if (selectedCandidates?.length === filteredCandidates?.length) {
      setSelectedCandidates([]);
    } else {
      setSelectedCandidates(filteredCandidates?.map((c) => c?.id));
    }
  };

  const handleStatusChange = (candidateId, newStatus) => {
    console.log(`Changing status for candidate ${candidateId} to ${newStatus}`);
    alert(`Status changed to ${newStatus}`);
  };

  const handleViewDetails = (candidate) => {
    setSelectedCandidate(candidate);
  };

  const handleBulkAction = (action) => {
    console.log(`Bulk action: ${action} for candidates:`, selectedCandidates);
    alert(`${action} applied to ${selectedCandidates?.length} candidates`);
    setSelectedCandidates([]);
  };

  const statusCounts = {
    all: mockCandidates?.length,
    Applied: mockCandidates?.filter((c) => c?.status === 'Applied')?.length,
    'Under Review': mockCandidates?.filter((c) => c?.status === 'Under Review')?.length,
    Shortlisted: mockCandidates?.filter((c) => c?.status === 'Shortlisted')?.length,
    'Interview Scheduled': mockCandidates?.filter((c) => c?.status === 'Interview Scheduled')?.length,
    Rejected: mockCandidates?.filter((c) => c?.status === 'Rejected')?.length
  };

  return (
    <MainLayout>
      <div className="max-w-7xl mx-auto">
        <div className="mb-6 md:mb-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
            <div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2">
                Candidate Management
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                Review, evaluate, and manage applicants throughout the hiring process
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Button
                variant={viewMode === 'grid' ? 'default' : 'outline'}
                size="sm"
                onClick={() => setViewMode('grid')}
                iconName="Grid3x3" />

              <Button
                variant={viewMode === 'list' ? 'default' : 'outline'}
                size="sm"
                onClick={() => setViewMode('list')}
                iconName="List" />

            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            {Object.entries(statusCounts)?.map(([status, count]) =>
            <button
              key={status}
              onClick={() => handleFilterChange('status', status)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-smooth ${
              filters?.status === status ?
              'bg-primary text-primary-foreground' :
              'bg-card border border-border text-card-foreground hover:bg-muted'}`
              }>

                {status === 'all' ? 'All' : status} ({count})
              </button>
            )}
          </div>
        </div>

        <div className="flex gap-6">
          <div className="hidden lg:block w-80 flex-shrink-0">
            <SavedFilterPresets
              presets={savedPresets}
              onLoadPreset={handleLoadPreset}
              onDeletePreset={handleDeletePreset}
              onSavePreset={handleSavePreset}
              currentFilters={filters}
            />
            <CandidateFilterPanel
              filters={filters}
              onFilterChange={handleFilterChange}
              onClearFilters={handleClearFilters}
              resultCount={filteredCandidates?.length} />

          </div>

          <button
            onClick={() => setIsFilterOpen(true)}
            className="lg:hidden fixed bottom-6 right-6 w-14 h-14 bg-primary text-primary-foreground rounded-full shadow-lg flex items-center justify-center z-30"
            aria-label="Open filters">

            <Icon name="Filter" size={24} />
          </button>

          {isFilterOpen &&
          <div className="lg:hidden fixed inset-0 z-40 bg-background overflow-y-auto">
              <div className="p-4">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-xl font-semibold">Filters</h2>
                  <button onClick={() => setIsFilterOpen(false)}>
                    <Icon name="X" size={24} />
                  </button>
                </div>
                <SavedFilterPresets
                  presets={savedPresets}
                  onLoadPreset={handleLoadPreset}
                  onDeletePreset={handleDeletePreset}
                  onSavePreset={handleSavePreset}
                  currentFilters={filters}
                />
                <CandidateFilterPanel
                filters={filters}
                onFilterChange={handleFilterChange}
                onClearFilters={handleClearFilters}
                resultCount={filteredCandidates?.length} />

              </div>
            </div>
          }

          <div className="flex-1">
            {selectedCandidates?.length > 0 &&
            <BulkActionBar
              selectedCount={selectedCandidates?.length}
              onBulkAction={handleBulkAction}
              onSelectAll={handleSelectAll}
              allSelected={selectedCandidates?.length === filteredCandidates?.length} />

            }

            <div className={viewMode === 'grid' ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : 'space-y-4'}>
              {filteredCandidates?.map((candidate) =>
              <CandidateCard
                key={candidate?.id}
                candidate={candidate}
                isSelected={selectedCandidates?.includes(candidate?.id)}
                onSelect={handleSelectCandidate}
                onStatusChange={handleStatusChange}
                onViewDetails={handleViewDetails}
                viewMode={viewMode} />

              )}
            </div>

            {filteredCandidates?.length === 0 &&
            <div className="text-center py-12">
                <Icon name="Users" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
                <h3 className="text-lg font-semibold text-card-foreground mb-2">No candidates found</h3>
                <p className="text-sm text-muted-foreground mb-4">Try adjusting your filters</p>
                <Button variant="outline" onClick={handleClearFilters}>Clear Filters</Button>
              </div>
            }
          </div>
        </div>
      </div>

      {selectedCandidate &&
      <CandidateDetailModal
        candidate={selectedCandidate}
        onClose={() => setSelectedCandidate(null)}
        onStatusChange={handleStatusChange} />

      }
    </MainLayout>);

};

export default CandidateManagement;